import allCategories from '@data/cats.json';
import enabledBrands from '@data/enabled-brands.json';
import shareImageData from '@data/share-image-data.json';
import { useLocale, useTranslations } from 'next-intl';
import styled from 'styled-components';
import AppBanner from '@/components/app-banner';
import CategoriesGrid from '@/components/categories-grid';
import Hero from '@/components/home/hero';
import LogoMarquee from '@/components/home/logo-marquee';
import { selectHomeBrands } from '@/components/home/select-brands';
import HowItWorks from '@/components/how-it-works';
import SEO from '@/components/seo';
import StablecoinsTeaser from '@/components/stablecoins-teaser';
import Testimonials from '@/components/testimonials';
import { Section, SectionHeader } from '@/components/ui';
import config from '@/config';
import { loadMessages } from '@/lib/messages';
import { localeRoot } from '@/utils/locale-path';
import { shareImage } from '@/utils/share-image';

const Categories = styled(CategoriesGrid)`
  margin-top: 48px;
`;

const Index = ({ brands, canonicalUrl, categories }) => {
  const t = useTranslations('home');
  const locale = useLocale();

  return (
    <>
      <SEO
        description={t('metaDescription')}
        hreflangPath="/"
        imageAlt={t('title')}
        imageUrl={shareImage.home(locale)}
        title={t('metaTitle')}
        url={canonicalUrl}
      />

      <Hero brands={brands} />

      <LogoMarquee brands={brands} label={t('marqueeLabel')} trademark={t('trademark')} />

      <Section id="categories">
        <SectionHeader
          description={t('categoriesLead')}
          eyebrow={t('categoriesEyebrow')}
          title={t('categoriesTitle')}
        />
        <Categories
          categories={[
            ...categories,
            { id: 'all', slug: 'giftcard', href: '/buy', label: t('allGiftCards') },
          ]}
        />
      </Section>

      <HowItWorks />

      <Testimonials />

      <StablecoinsTeaser />

      <AppBanner />
    </>
  );
};

// The catalogue imports above are only read here, so they stay out of the client bundle.
export async function getStaticProps({ locale }) {
  // As in sitemap.xml: the origin plus `/` for the default locale, `/fr` (no
  // trailing slash, which would redirect) for the others.
  const canonicalUrl = `${config.rootUrl}${localeRoot(locale)}`;

  return {
    props: {
      // Without the brands whose logo file the build found missing (format-data.js).
      brands: selectHomeBrands(enabledBrands, 24, {
        missingLogos: shareImageData.missingLogos,
      }),
      canonicalUrl,
      categories: allCategories.map(({ id, slug }) => ({ id, slug })),
      messages: loadMessages(locale),
    },
  };
}

export default Index;
